export default __webpack_public_path__ + "static/media/exampleImage1.ad28696b.jpg";